"use client";
import {
  usePopoverHeading
} from "../__chunks/6DEDXFNU.js";
import "../__chunks/TIW3GMFC.js";
import "../__chunks/44L5375W.js";
import {
  SelectHeadingContext
} from "../__chunks/KPEX55MY.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/CZ4GFWYL.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/LMDWO4NN.js";
import {
  useId,
  useSafeLayoutEffect
} from "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import {
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/select/select-heading.tsx
import { useContext } from "react";
var TagName = "h1";
var useSelectHeading = createHook(
  function useSelectHeading2(props) {
    const [, setHeadingId] = useContext(SelectHeadingContext) || [];
    const id = useId(props.id);
    useSafeLayoutEffect(() => {
      setHeadingId == null ? void 0 : setHeadingId(id);
      return () => setHeadingId == null ? void 0 : setHeadingId(void 0);
    }, [setHeadingId, id]);
    props = __spreadValues({
      id
    }, props);
    props = usePopoverHeading(props);
    return props;
  }
);
var SelectHeading = forwardRef(function SelectHeading2(props) {
  const htmlProps = useSelectHeading(props);
  return createElement(TagName, htmlProps);
});
export {
  SelectHeading,
  useSelectHeading
};
